import cn from 'classnames';
import Link from 'next/link';
import { HeaderActionsPlatform } from '@/shared/ui/kit/header-actions';
import { Topbar, TopbarActions, TopbarBrand, TopbarNavigation } from '@/shared/ui/layout';
import { MobileMenuSheet } from '@/shared/ui/kit/mobile-menu-sheet';
import { HOME_PATHNAME } from '@/shared/constants/pathnames';
import { HeaderProps } from '../model/header.props';
import Logo from '../assets/logo.svg';
import styles from './header.module.scss';


export const Header = ({ profile, HeaderMobileMenuSheet, HeaderNavigation, HeaderActions, className }: HeaderProps) => {
    return (
        <div className={ cn(styles.wrapper, className) }>
            <Topbar className={ styles.root }>
                <TopbarBrand className={ styles.topbar_brand }>
                    <Link href={ HOME_PATHNAME }>
                        <Logo className={ styles.logo }/>
                    </Link>
                </TopbarBrand>

                {
                    HeaderNavigation &&
                    <TopbarNavigation>
                        <HeaderNavigation/>
                    </TopbarNavigation>
                }

                {
                    HeaderMobileMenuSheet &&
                    <HeaderMobileMenuSheet profile={ profile }/>
                }

                {
                    !HeaderMobileMenuSheet &&
                    <MobileMenuSheet profile={ profile }/>
                }

                <TopbarActions className={ styles.actions }>
                    {
                        HeaderActions &&
                        <HeaderActions profile={ profile }/>
                    }
                    {
                        !HeaderActions &&
                        <HeaderActionsPlatform profile={ profile }/>
                    }
                </TopbarActions>
            </Topbar>
        </div>
    );
};
